const data = [
  {
    id: "Men's Innerwear New Arrival",
    img: require("./Certificates/j1.pdf"),
    title: "Men's Innerwear New Arrival",
    icon: 'bx bx-building-house',
    company: 'PageIndustries Limited',
    obtain: '27-07-22',
    address_city: 'Banglore',
    address_country: 'India',
    desc: "This certification highlights the launch of a premium men’s innerwear collection designed for ultimate comfort, durability, and contemporary style. Featuring breathable fabrics and modern fits, the products ensure long-lasting performance, catering to customers seeking both functionality and fashion in everyday essentials.",
    short_desc: "Premium innerwear with comfort and style.",
  },
  {
    id: "New Arrivals and changes",
    img: require("./Certificates/j2.pdf"),
    title: "New Arrivals and changes",
    icon: 'bx bx-building-house',
    company: 'PageIndustries Limited',
    obtain: '03-01-25',
    address_city: 'Banglore',
    address_country: 'India',
    desc: "This certificate recognizes the release of exciting new product arrivals along with significant updates to existing collections. Customers benefit from improved features, enhanced product quality, and an upgraded overall experience, reinforcing the company’s commitment to innovation, modern fashion, and continuous customer satisfaction.",
    short_desc: "Showcasing new arrivals with product improvements.",
  },
  {
    id: "Introduction to PAGE",
    img: require("./Certificates/j3.pdf"),
    title: "Introduction to PAGE",
    icon: 'bx bx-building-house',
    company: 'PageIndustries Limited',
    obtain: '07-01-25',
    address_city: 'Banglore',
    address_country: 'India',
    desc: "A certification introducing PAGE platform fundamentals, outlining its features, benefits, and structured learning framework. It emphasizes professional application, streamlined functionality, and practical implementation, ensuring learners develop both theoretical knowledge and applied expertise to leverage PAGE solutions effectively in diverse industry and business contexts.",
    short_desc: "Comprehensive overview of PAGE platform essentials.",
  },
  {
    id: "M12 Boxer Shorts",
    img: require("./Certificates/j4.pdf"),
    title: "M12 Boxer Shorts",
    icon: 'bx bx-building-house',
    company: 'PageIndustries Limited',
    obtain: '14-02-24',
    address_city: 'Banglore',
    address_country: 'India',
    desc: "This certification highlights the launch of premium M12 boxer shorts, crafted with high-quality breathable fabrics that ensure superior comfort. Designed for durability and perfect fit, the product combines style with practicality, providing customers with long-lasting wear, confidence, and ease for everyday use.",
    short_desc: "Breathable boxer shorts ensuring comfort daily.",
  },
  {
    id: "SCSS: Proficient",
    img: require("./Certificates/w3.pdf"),
    title: "SCSS: Proficient",
    icon: 'bx bx-bracket-curly',
    company: 'W3 School',
    obtain: '16-04-23',
    address_city: 'California',
    address_country: 'USA',
    desc: "Certification validating advanced proficiency in SCSS, showcasing expertise in creating scalable and modular styling solutions. The credential demonstrates strong command of responsive design principles, maintainable code structures, and efficient workflows, enabling developers to deliver optimized, future-proof web interfaces across multiple devices and platforms seamlessly.",
    short_desc: "Advanced styling with SCSS proficiency certified.",
  },
  {
    id: "Cloud for CEOs",
    img: require("./Certificates/aws1.pdf"),
    title: "Cloud for CEOs",
    icon: 'bx bx-cloud',
    company: 'Amazon Web Services',
    obtain: '13-03-23',
    address_city: 'Virginia',
    address_country: 'USA',
    desc: "An executive-level certification introducing CEOs to cloud computing fundamentals. It emphasizes strategic advantages such as business agility, scalability, cost-effectiveness, and digital transformation. The credential equips leaders with knowledge to leverage cloud solutions for innovation, competitive advantage, and organizational growth in an increasingly digital business landscape.",
    short_desc: "Cloud fundamentals for CEOs and leaders.",
  },
  {
    id: "Amazon Macie",
    img: require("./Certificates/aws2.pdf"),
    title: "Amazon Macie",
    icon: 'bx bx-terminal',
    company: 'Amazon Web Services',
    obtain: '14-09-24',
    address_city: 'Virginia',
    address_country: 'USA',
    desc: "Certification covering Amazon Macie, a data security service designed for sensitive data discovery, classification, and protection. It validates skills in managing privacy risks, ensuring regulatory compliance, and implementing strong security practices. Learners gain proficiency in safeguarding organizational data against threats in dynamic cloud environments.",
    short_desc: "Data security with Amazon Macie certification.",
  },
];

export default data;
